import React from "react";
import NavbarWhite from "../components/NavbarWhite";
import Contatti from "../components/Contatti";
import Footer from "../components/Footer";
import ContactForm from "../components/ContactForm";
import logo from "../logo.png";

const ContattiPage = () => {
  return (
    <div className="bg-white text-black min-h-screen">
      <NavbarWhite />

      {/* Add padding top to prevent overlap */}
      <div className="pt-32">
        <Contatti />
      </div>

      <ContactForm />

      {/* Separator */}
      <div className="my-8 border-t border-gray-300 w-3/4 mx-auto" />

      {/* Business Info Section */}
      <div className="max-w-2xl mx-auto px-4 py-8 text-center text-sm sm:text-base">
               <div className="mt-10">
                    <img
                      src={logo}
                      alt="Lido Da Vittorio"
                      className="h-28 sm:h-32 md:h-36 mb-6 mx-auto sm:mb-8"
                    />
                  </div>
        <h2 className="text-xl font-semibold mb-2">DA VITTORIO SAS</h2>
        <p>di Gianluca Antonio Mario & Co.</p>
        <p>via C. Colombo - Marina di Vico Equense (Na)</p>
        <p>Partita IVA: 09646541210</p>
        <p>
          Email PEC:{" "}
          <a
            href="mailto:davittoriosas@pec.it"
            className="text-blue-600 underline"
          >
            davittoriosas@pec.it
          </a>
        </p>
        <p>Codice Univoco (CU): 5RUO82D</p>
      </div>

      <Footer />
    </div>
  );
};

export default ContattiPage;
